import React, { useState, ChangeEvent, useRef } from 'react';
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'
import '../App.css';
import PageLoader from '../components/PageLoader';
import { ToastContainer, toast } from 'react-toastify';
import _ from 'lodash';

import Auth from '../core/services/auth';
import { useNavigate, NavLink } from 'react-router-dom';
import Back from '../components/backComponent';
import Avatar from 'react-avatar';

function Account () {
    // navigate to Login
    const navigate = useNavigate();
    const [ displayName, setDisplayName ] = useState('')
    const [ fullname, setFullname ] = useState('')
    const [ country, setCountry ] = useState('233')
    const [ phone, setPhone ] = useState('')
    const [ DOB, setDOB ] = useState('')
    const [ gender, setGender ] = useState('')
    const [ loading, setLoading ] = useState(false)
    const [ openPersonal, setOpenPersonal ] = useState(false)
    const [ openUsername, setOpenUsername ] = useState(false)
    const [ openBlocked, setOpenBlocked ] = useState(false)
    
    const [ openDeleteAccount, setOpenDeleteAccount ] = useState(false)
    const inputLogoRef = useRef<HTMLInputElement>(null)

    const [ logo, setLogo ] = useState<File>()
    
    function handleLogoClick (e: any) {
        // console.log(e)

        inputLogoRef.current?.click()
    }

    Auth.authUser().then(res => {
      //
      Auth.setUser(res.data.data.user)
    });

    const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
      
        setLoading(true)

        if (event.target.files) {
            setLogo(event.target.files[0])
            // setLogo(URL.createObjectURL(event.target.files[0] ))
            // URL.createObjectURL(event.target.files[0])

            //
            Auth.updateProfileImage(event.target.files[0]).then(res=>{

              setLoading(false)
      
              //  update user profile
              Auth.authUser().then(res => {
                //
                Auth.setUser(res.data.data.user)
                //
                const vendors = res.data.data.vendorAdmins.map(({ vendor }: any) => vendor)
                //
                for (let index = 0; index < vendors.length; index++) {
                  const vendor = vendors[index];
                  Auth.setVendor(vendor)
                }
                
              })
      
              toast.success(res.data.message, {
                position: "top-center",
              });

              navigate(-1)
      
            }).catch(err=>{
      
              setLoading(false)
              
              console.log(err)
      
              if (typeof(err.response) !== "undefined") {
                if (err.response.data && _.isArray(err.response.data.error)) {
                    let error = err.response.data.error
                    //
                    for (let index = 0; index < error.length; index++) {
                      const err = error[index];
                      toast.error(err.message, {
                        position: "top-center",
                      });
                    }
                  } else {
                    toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
                      position: "top-center",
                    });
                  }
            }
            })
        }
    }

    const setImage = () => {
      return URL.createObjectURL(logo as Blob)
    }

    const user = Auth.getUser()
    //
    // setFullname(user.profile.firstName+' '+user.profile.lastName)
    // setGender(user.profile.gender)

    const blockedList = user.blocked_users.map(
      // _story => <StoryComponent story={_story} />
      // _story => <li> {_story.caption} </li>
      (_user: any) => 
          <button key={_user} onClick={e=>unblockUser(_user.id)} type="button" className="relative inline-flex items-center w-full px-2 py-3 font-medium rounded-lg bg-gray-100 hover:text-gray-400  focus:z-10 focus:ring-2 focus:ring-gray-400 focus:text-gray-400 dark:bg-black dark:border-gray-600 dark:hover:bg-gray-600 dark:hover:text-white dark:focus: ring-gray-500 dark:focus:text-white">

                <svg className="w-6 h-6 me-2.5  dark:fill-white" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="AddCircleOutlineOutlinedIcon"><path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"></path></svg>
                    <p className='font-medium text-xs'>{_user.username}</p>
              </button>
  )

    const logout = ()=> {
      Auth.logout().then(()=>{
        //
        navigate('/login')
      })
    };

    const deleteAccount = () => {
      //
      setLoading(true)
      Auth.api.delete("/users").then(res=>{
         
        //
        toast.success("Successfully Deleted Account!", {
          position: "top-center",
        });

        // check if success
        logout()
          
      }).catch((err)=>{
        //
        toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
                      position: "top-center",
                    });
      })
    }

    const unblockUser = (userId: string) => {

      if (userId) {
        Auth.api.get('/users/unblock/'+userId).then(res => {

          // console.log(res.data)
          // setLoading(true)
          //  setup vendor
          // Auth.setVendor(res.data.data)
          
          // setTimeout(()=>{
          //   // navigate 
          //   navigate('/vendor')
          // }, 1800)

          Auth.clearPostCached();

          toast.success(res.data.message, {
            position: "top-center",
          });
          
          setTimeout(()=>{
            setOpenBlocked(false)
          }, 600);
          // navigate(-1)

          Auth.authUser().then(res => {
            //
            Auth.setUser(res.data.data.user)
          });

        }).catch(err=>{

          console.log(err)

          // setLoading(false)

          if (_.isArray(err.response.data.error)) {
            let error = err.response.data.error
            //
            for (let index = 0; index < error.length; index++) {
              const err = error[index];
              toast.error(err.message, {
                position: "top-center",
              });
            }
          } else {
            toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
              position: "top-center",
            });
          }

        })

        setOpenBlocked(false)
      }
    }

    const handleUsernameSubmit = (event: any) => {
      //
      event.preventDefault()

      setLoading(true)

      Auth.changeUsername({ username: displayName ? displayName : user.username}).then(res=>{

        setLoading(false)

        //  update user profile
        Auth.authUser().then(res => {
          //
          Auth.setUser(res.data.data.user)
          //
          const vendors = res.data.data.vendorAdmins.map(({ vendor }: any) => vendor)
          //
          for (let index = 0; index < vendors.length; index++) {
            const vendor = vendors[index];
            Auth.setVendor(vendor)
          }
          
        })

        toast.success("Successfully updated @username", {
          position: "top-center",
        });

      }).catch(err=>{

        setLoading(false)
        
        console.log(err)

        if (typeof(err.response) !== "undefined") {
          if (err.response.data && _.isArray(err.response.data.error)) {
              let error = err.response.data.error
              //
              for (let index = 0; index < error.length; index++) {
                const err = error[index];
                toast.error(err.message, {
                  position: "top-center",
                });
              }
            } else {
              toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
                position: "top-center",
              });
            }
      }
      })
    }
    
    const handlePersonalSubmit = (event: any) => {
      
      event.preventDefault();

      setLoading(true)
      
      // console.log(code)
      const name = fullname.split(' ')

      //  set form data
      const formData = {
          firstName: name[0] ? name[0] : user.profile.firstName,
          lastName: fullname ? (!name[1] ? '' : name[1]) : user.profile.lastName,
          gender: gender ? gender : user.profile.gender,
          dob: DOB ? DOB :  user.profile.dob,
          country: country ? country : user.profile.phone.substring(0, 3),
          phone: country+phone ? country+phone : user.profile.phone.substring(3),
      }

      Auth.updateUser(formData).then(res => {
          setLoading(false)

          //  get user profile
          Auth.authUser().then(res => {
            //
            Auth.setUser(res.data.data.user)
            //
            const vendors = res.data.data.vendorAdmins.map(({ vendor }: any) => vendor)
            //
            for (let index = 0; index < vendors.length; index++) {
              const vendor = vendors[index];
              Auth.setVendor(vendor)
            }
            
          })
            
          toast.success(res.data.message, {
            position: "top-center",
          });

        }).catch(err=>{
  
          console.log(err)
  
          setLoading(false)

          // setTimeout(()=>{
          //   // navigate 
          //   navigate('/verify-password', { state: { email: email, otp: code } })
          // }, 1800)

          if (typeof(err.response) !== "undefined") {
              if (err.response.data && _.isArray(err.response.data.error)) {
                  let error = err.response.data.error
                  //
                  for (let index = 0; index < error.length; index++) {
                    const err = error[index];
                    toast.error(err.message, {
                      position: "top-center",
                    });
                  }
                } else {
                  toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
                    position: "top-center",
                  });
                }
          }
          
  
        })
    }

    return (
        <section className='dark:bg-gray-800 dark:text-white'>
          { loading ? <PageLoader /> : '' }
          <ToastContainer />
          <Back title='My Profile'/>
          
          <div className="flex flex-col px-6 py-8 mx-auto md:h-screen lg:py-0">
            

          <div className='flex w-full justify-center'>
              <div className="flex flex-col items-center space-y-1 relative">
                        {('profileImage' in user.profile) &&
                        
                          <div style={{width:'105px', height: '105px'}} className="border bg-gray-100 border-slate-400 rounded-full">
                              <div className="bg-white block rounded-full  hover:-rotate-6 transform transition">
                                <img alt='profile' className='rounded-full object-cover aspect-square p-1' src={!user.profile.profileImage.url ? setImage() : user.profile.profileImage.url}/>
                              </div>
                          </div>
                          
                        }
                        
                        { !(user.profile.profileImage || logo) &&
                          <Avatar round={true} size='105' name={ user.profile.firstName && user.profile.lastName ? user.profile.firstName+' '+user.profile.lastName: user.email } />
                        }
                        
                        <div className='' style={{width:'105px', height: '5px'}}>
                            <button onClick={handleLogoClick} className="relative bottom-9 float-right bg-slate-800 rounded h-6 w-6 
                            text-white font-semibold border-2
                            border-white flex justify-center items-center font-mono hover:bg-blue-700">+</button>
                        </div>
                        <div>
                          <h2 className='text-md font-bold mb-0 pb-0'>{ user.profile.firstName && user.profile.lastName ? user.profile.firstName+' '+user.profile.lastName: user.email }</h2>
                          <p className='text-sm text-gray-500 mb-0 pb-0'>@{ user.username.split('-').length > 2 ? user.username.split('-')[0] : user.username }</p>
                        </div>
                </div>
          </div>
          
          <div className='py-5 px-2  text-left'>
            <p className='text-sm font-medium'> Settings</p>
          </div>
          <div className="w- text-gray-900 bg-white rounded-lg  dark:border-gray-600 dark:text-white dark:bg-gray-800">
              <button type="button" onClick={e=>setOpenPersonal(true)} className="relative inline-flex items-center w-full px-4 py-3 font-medium  rounded-t-lg bg-gray-100 hover:text-gray-400  focus:z-10 focus:ring-2 focus:ring-gray-400 focus:text-gray-400  dark:border-gray-600 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:ring-gray-500 dark:focus:text-white dark:bg-gray-800">
                  <svg className="w-7 h-7 me-2.5 dark:fill-white" aria-hidden="true" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M7.35 18.5C8.66 17.56 10.26 17 12 17s3.34.56 4.65 1.5c-1.31.94-2.91 1.5-4.65 1.5s-3.34-.56-4.65-1.5m10.79-1.38C16.45 15.8 14.32 15 12 15s-4.45.8-6.14 2.12C4.7 15.73 4 13.95 4 12c0-4.42 3.58-8 8-8s8 3.58 8 8c0 1.95-.7 3.73-1.86 5.12"></path><path d="M12 6c-1.93 0-3.5 1.57-3.5 3.5S10.07 13 12 13s3.5-1.57 3.5-3.5S13.93 6 12 6m0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11"></path></svg>
                  Personal Details
              </button>
              <NavLink to="/change-password">
                <button type="button" className="relative inline-flex items-center w-full px-4 py-3 font-medium  bg-gray-100 hover:text-gray-400  focus:z-10 focus:ring-2 focus:ring-gray-400 focus:text-gray-400  dark:border-gray-600 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:ring-gray-500 dark:focus:text-white dark:bg-gray-800">
                    <svg className="w-7 h-7 me-2.5 dark:fill-white" aria-hidden="true" viewBox="0 0 24 24"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2M9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9zm9 14H6V10h12zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2"></path></svg>
                    Change Password
                </button>
              </NavLink>
              
              <button type="button" onClick={e=>setOpenUsername(true)} className="relative inline-flex items-center w-full px-4 py-3 font-medium rounded-b-lg bg-gray-100 hover:text-gray-400  focus:z-10 focus:ring-2 focus:ring-gray-400 focus:text-gray-400  dark:border-gray-600 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:ring-gray-500 dark:focus:text-white dark:bg-gray-800">
                    <svg className="w-7 h-7 me-2.5 dark:fill-white" aria-hidden="true" viewBox="0 0 24 24"><path d="M12 1.95c-5.52 0-10 4.48-10 10s4.48 10 10 10h5v-2h-5c-4.34 0-8-3.66-8-8s3.66-8 8-8 8 3.66 8 8v1.43c0 .79-.71 1.57-1.5 1.57s-1.5-.78-1.5-1.57v-1.43c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5c1.38 0 2.64-.56 3.54-1.47.65.89 1.77 1.47 2.96 1.47 1.97 0 3.5-1.6 3.5-3.57v-1.43c0-5.52-4.48-10-10-10m0 13c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3"></path></svg>
                  Change Username
              </button>
              
              <button type="button" onClick={e=>setOpenBlocked(true)} className="relative inline-flex items-center w-full px-4 py-3 font-medium rounded-b-lg bg-gray-100 hover:text-gray-400  focus:z-10 focus:ring-2 focus:ring-gray-400 focus:text-gray-400  dark:border-gray-600 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:ring-gray-500 dark:focus:text-white dark:bg-gray-800">
                  <svg className="w-7 h-7 me-2.5 dark:fill-white" aria-hidden="true" viewBox="0 0 24 24" data-testid="BlockIcon"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12m8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8"></path></svg>
                  Blocked Accounts
              </button>
              
          </div>
            <div className='py-4'>

            </div>
            
            <button onClick={e=>logout()} type="button" className="relative inline-flex items-center w-full px-4 py-3  font-medium rounded-b-lg dark:border-gray-600 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:ring-gray-500 dark:focus:text-white">
                  <svg className="w-7 h-7 me-2.5 dark:fill-white" aria-hidden="true" viewBox="0 0 24 24"><path d="m17 8-1.41 1.41L17.17 11H9v2h8.17l-1.58 1.58L17 16l4-4zM5 5h7V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h7v-2H5z"></path></svg>
                  Logout
              </button>

              <button onClick={e=>setOpenDeleteAccount(true)} type="button" className="relative inline-flex items-center text-yellow-800 w-full px-3 py-3 my-3 font-medium rounded-b-lg  dark:hover:bg-gray-600 dark:hover:text-white dark:focus:ring-gray-500 dark:focus:text-white">
                  <svg className="w-7 h-7 me-3 fill-yellow-800" aria-hidden="true" viewBox="0 0 24 24" data-testid="DeleteOutlineIcon"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM8 9h8v10H8zm7.5-5-1-1h-5l-1 1H5v2h14V4z"></path></svg>
                  Delete Account
              </button>

             {/* file input */}
             <input ref={inputLogoRef} accept='image/*' type="file" name="logo" id="logo" className="invisible bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ handleFileChange } placeholder="Logo" required={true}/>               
          </div>

          {/* Form Modal */}
          <Dialog open={openPersonal} onClose={setOpenPersonal} className="relative z-10">
            <DialogBackdrop
              transition
              className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
                <DialogPanel
                  transition
                  className="relative w-full transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 dark:bg-gray-800 dark:text-white"
                >
                  <form onSubmit={handlePersonalSubmit} style={{width: '100%'}} className="space-y-4 p-6">
                          <div className='pt-2 px-2  text-left'>
                            <p className='text-sm font-medium'> Personal Details</p>
                          </div>
                          <div>
                            <input type="text" minLength={4} name="fullname" id="fullname" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setFullname(e.target.value) } placeholder="Firstname Lastname" value={fullname ? fullname : '' } required={true}/>
                          </div>
                          <div className='grid grid-cols-3 gap-4'>
                            <div>
                                <input type="text" name="country" id="country" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setCountry(e.target.value) } placeholder="Country" value={country ? country : user.profile.phone?.substring(0, 3)} required={true}/>
                            </div>
                            <div className='col-span-2'>
                                <input type="tel" name="phone" id="phone" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setPhone(e.target.value) } placeholder="Phone" value={phone ? phone : user.profile.phone?.substring(3)} required={true}/>
                            </div>
                          </div>
                          <div className='grid grid-cols-2 gap-4'>
                            <div className=''>
                              <input type="date" name="displayName" id="displayName" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-3.5 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setDOB(e.target.value) } value={DOB ? DOB : user.profile.dob}/>
                            </div>
                            <div>
                              <select id="countries" className="bg-gray-50 text-gray-900 text-sm rounded-lg focus:ring-grey-600 focus:border-blue-500 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              value={gender ? gender : user.profile.gender} onChange={e=>setGender(e.target.value)}>
                                <option selected>Select Gender</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                                <option value="other">Other</option>
                              </select>
                            </div>
                            
                          </div>
                          <div className='w-full  space-y-4 '>
                            <button type="submit" className="w-full rounded-full text-white bg-yellow-800 hover:bg-yellow-700 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium text-sm px-5 py-4 text-center dark:bg-yellow-600 dark:hover:bg-yellow-700 dark:focus:ring-yellow-800">Update</button>
                            
                          </div>
                    </form>
                  {/* <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                    <button
                      type="button"
                      onClick={() => setOpen(false)}
                      className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                    >
                      Deactivate
                    </button>
                    <button
                      type="button"
                      data-autofocus
                      onClick={() => setOpen(false)}
                      className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    >
                      Cancel
                    </button>
                  </div> */}
                </DialogPanel>
              </div>
            </div>
          </Dialog>


          <Dialog open={openUsername} onClose={setOpenUsername} className="relative z-20">
            <DialogBackdrop
              transition
              className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
                <DialogPanel
                  transition
                  className="relative w-full transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 dark:bg-gray-800 dark:text-white"
                >
                  <form onSubmit={handleUsernameSubmit} className="space-y-4 p-6 w-full">
                          <div className='pt-2 px-2  text-left'>
                            <p className='text-sm font-medium'> Username</p>
                          </div>
                          <div className=''>
                            <input type="text" minLength={3} name="displayName" id="displayName" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setDisplayName(e.target.value) } placeholder="@Username" value={displayName ? displayName : user.username} required={true}/>
                            
                          </div>
                          {/* <div>
                            <input type="text" minLength={4} name="fullname" id="fullname" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setFullname(e.target.value) } placeholder="Firstname Lastname" value={fullname} required={true}/>
                          </div>
                          <div className='grid grid-cols-3 gap-4'>
                            <div>
                                <input type="text" name="country" id="country" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setCountry(e.target.value) } placeholder="Country" value={country} required={true}/>
                            </div>
                            <div className='col-span-2'>
                                <input type="tel" name="phone" id="phone" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setPhone(e.target.value) } placeholder="Phone" value={phone} required={true}/>
                            </div>
                          </div> */}
                          <div className='flex flex-col space-y-4 '>
                            <button type="submit" className="w-full rounded-full text-white bg-yellow-800 hover:bg-yellow-700 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium text-sm px-5 py-4 text-center dark:bg-yellow-600 dark:hover:bg-yellow-700 dark:focus:ring-yellow-800">Update</button>
                            
                          </div>
                    </form>
                  {/* <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                    <button
                      type="button"
                      onClick={() => setOpen(false)}
                      className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                    >
                      Deactivate
                    </button>
                    <button
                      type="button"
                      data-autofocus
                      onClick={() => setOpen(false)}
                      className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    >
                      Cancel
                    </button>
                  </div> */}
                </DialogPanel>
              </div>
            </div>
          </Dialog>


          <Dialog open={openBlocked} onClose={setOpenBlocked} className="relative z-20">
            <DialogBackdrop
              transition
              className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
                <DialogPanel
                  transition
                  className="relative w-full transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 dark:bg-gray-800 dark:text-white"
                >
                  <div className="space-y-4 p-6 w-full">
                    <div className='pt-2 px-2  text-left'>
                      <p className='text-sm font-medium'> Blocked Accounts</p>
                    </div>
                    <div className="w- text-gray-900 bg-white rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white ">
                      {blockedList}
                    </div>
                  </div>
                  {/* <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                    <button
                      type="button"
                      onClick={() => setOpen(false)}
                      className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                    >
                      Deactivate
                    </button>
                    <button
                      type="button"
                      data-autofocus
                      onClick={() => setOpen(false)}
                      className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    >
                      Cancel
                    </button>
                  </div> */}
                </DialogPanel>
              </div>
            </div>
          </Dialog>


          <Dialog open={openDeleteAccount} onClose={setOpenDeleteAccount} className="relative z-20">
            <DialogBackdrop
              transition
              className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
                <DialogPanel
                  transition
                  className="relative w-full transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 dark:bg-gray-800 dark:text-white"
                >
                  <div className="space-y-4 p-6 w-full">
                          <div className='pt-2 px-2  text-left'>
                            <p className='text-sm font-medium'> Are you sure you want to "Delete Your Account"?</p>
                          </div>
                          {/* <div>
                            <input type="text" minLength={4} name="fullname" id="fullname" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setFullname(e.target.value) } placeholder="Firstname Lastname" value={fullname} required={true}/>
                          </div>
                          <div className='grid grid-cols-3 gap-4'>
                            <div>
                                <input type="text" name="country" id="country" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setCountry(e.target.value) } placeholder="Country" value={country} required={true}/>
                            </div>
                            <div className='col-span-2'>
                                <input type="tel" name="phone" id="phone" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setPhone(e.target.value) } placeholder="Phone" value={phone} required={true}/>
                            </div>
                          </div> */}
                          <div className='flex flex-col space-y-4 '>
                            <button onClick={e=>setOpenDeleteAccount(false)} type="button" className="w-full rounded-full text-dark bg-whoite hover:bg-gray-50 border border-slate-300 focus:ring-4 border-slate-500 focus:outline-none focus:ring-primary-300 font-medium text-sm px-5 py-4 text-center dark:bg-black dark:hover:bg-gray-800 dark:focus:ring-primary-800 dark:hover:border-gray-400 dark:border-black">No, Cancel</button>

                            <button onClick={e=>deleteAccount()} type="button" className="w-full rounded-full text-white bg-yellow-800 hover:bg-yellow-700 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium text-sm px-5 py-4 text-center dark:bg-yellow-600 dark:hover:bg-yellow-700 dark:focus:ring-yellow-800">Yes Delete Account</button>
                            
                          </div>
                    </div>
                  {/* <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                    <button
                      type="button"
                      onClick={() => setOpen(false)}
                      className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                    >
                      Deactivate
                    </button>
                    <button
                      type="button"
                      data-autofocus
                      onClick={() => setOpen(false)}
                      className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    >
                      Cancel
                    </button>
                  </div> */}
                </DialogPanel>
              </div>
            </div>
          </Dialog>
        </section>
    );
  }
  
  export default Account;